import { clsx } from 'clsx';
import { useState } from 'react';

import './ValueButtonGroup.scss';

export const ValueButtonGroup = ({
  options,
  hasPlus,
  formatLabel,
  min,
  max,
  onRangeChange,
}: {
  options: number[];
  hasPlus?: boolean;
  formatLabel?: (option: number, index: number) => string;
  min?: number;
  max?: number;
  onRangeChange?: (min?: number, max?: number) => void;
}) => {
  const [anchor, setAnchor] = useState<number>();
  const getLabel = (option: number, index: number) => {
    if (formatLabel) return formatLabel(option, index);
    return hasPlus && index === options.length - 1 ? `${option}+` : `${option}`;
  };

  const handleClick = (option: number) => {
    if (anchor === undefined) {
      if (min !== undefined && max !== undefined && min === max && min === option) {
        onRangeChange?.(undefined, undefined);
        return;
      }
      setAnchor(option);
      onRangeChange?.(option, option);
      return;
    }

    if (anchor === option) {
      setAnchor(undefined);
      onRangeChange?.(undefined, undefined);
      return;
    }

    const nextMin = Math.min(anchor, option);
    const nextMax = Math.max(anchor, option);
    setAnchor(undefined);
    onRangeChange?.(nextMin, nextMax);
  };

  return (
    <div className="value-button-group">
      <div className="mode-switcher">
        {options.map((option, index) => {
          const isSelected =
            min !== undefined && max !== undefined && option >= min && option <= max;

          return (
            // eslint-disable-next-line aloft/prefer-sound-ui-button
            <button
              key={option}
              type="button"
              className={clsx('button', 'secondary', 'sm', isSelected && 'range-selected')}
              onClick={() => handleClick(option)}
            >
              <div className="contents">{getLabel(option, index)}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
